import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import LoadingButton from "@material-ui/lab/LoadingButton";
import { useTranslation } from "react-i18next";
import { ArrowRight, Delete, Send } from "@material-ui/icons";
import {
  Autocomplete,
  Box,
  CircularProgress,
  Divider,
  Grid,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { VacancyType } from "../../users/types/user";
import {
  getVacancyAvaliableSYS,
  sendCandidateToVacancy,
  VacancyListType,
} from "../hooks/useVacancy";
import { useSnackbar } from "../../core/contexts/SnackbarProvider";

type ConfirmDialogProps = {
  description?: string;
  onClose: () => void;
  onConfirm: (
    id: number | undefined,
    type: number,
    vacancy: number | undefined,
    modalCVAutoHCode: number | undefined
  ) => void;
  open: boolean;
  pending: boolean;
  title: string;
  id: number | undefined;
  modalCVAutoHCode: number | undefined;
  delIndex?: number;
  onSuccess?: () => void;
};

const ModalSendCandidateToVacancy = ({
  description,
  onClose,
  onConfirm,
  open,
  pending,
  title,
  id,
  modalCVAutoHCode,
  onSuccess,
}: ConfirmDialogProps) => {
  const { t } = useTranslation();
  const [openAsyncVacancys, setOpenAsyncVacancys] = useState(false);
  const [loading, isLoading] = useState(false);

  const [options, setOptions] = useState<readonly VacancyListType[]>([]);
  const [vacancyId, setVacancyId] = useState<number>(0);

  const snackbar = useSnackbar();

  const getVacancysAvaliable = async (): Promise<any | boolean> => {
    isLoading(true);
    const data = await getVacancyAvaliableSYS();
    isLoading(false);
    if (data as any) {
      setOptions(data as VacancyListType[]);
      return data;
    }
    return false;
  };

  const sendCandidate = () => {
    const body = {
      canId: id,
      vacancyId: vacancyId,
    };
    if (vacancyId != 0) {
      sendCandidateToVacancy(body)
        .then((res) => {
          if (res != undefined) {
            snackbar.success("Candidato Encaminhado");
            if (onSuccess) {
              onSuccess();
            }
            onCloseF();
          } else {
            snackbar.error("Candidato já foi encaminhado para a vaga");
          }
        })
        .catch((e) => {
          snackbar.error("Candidato já foi encaminhado para a vaga");
        });
    } else {
      snackbar.error("Selecione uma vaga para encaminhar");
    }
  };

  useEffect(() => {
    getVacancysAvaliable();
  }, []);

  function onCloseF() {
    setVacancyId(0);
    onClose();
  }

  return (
    <Dialog
      open={open}
      onClose={onCloseF}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      PaperProps={{
        style: {
          overflowY: "visible",
        },
      }}
    >
      <DialogContent sx={{ textAlign: "center" }}>
        <DialogTitle id="confirm-dialog-title" sx={{ pb: 1, pt: 0 }}>
          {title}
        </DialogTitle>
        {description && (
          <DialogContentText
            style={{ textAlign: "center" }}
            id="confirm-dialog-description"
          >
            {description}
          </DialogContentText>
        )}
        <Grid container direction="row">
          <Grid item xs={12} md={12} lg={12}>
            <Autocomplete
              id="asynchronous-get-vacancy"
              open={openAsyncVacancys}
              onOpen={() => {
                setOpenAsyncVacancys(true);
              }}
              onClose={() => {
                setOpenAsyncVacancys(false);
              }}
              getOptionLabel={(option: VacancyListType) =>
                `${option.id} - (${option.cargo_nome}) - ${option.cliente_nome} em ${option.cidade}`
              }
              options={options}
              loading={loading}
              renderOption={(props, option) => (
                <Box
                  key={option.id}
                  component="li"
                  sx={{
                    "& > img": { mr: 2, flexShrink: 0 },
                    borderTop: "1px solid #333",
                  }}
                  {...props}
                >
                  <Grid container>
                    <Grid item xs={12}>
                      <b>{option.id}</b> {option.cargo_nome}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      Cidade: <b>{option.cidade}</b>
                    </Grid>
                    {option.cliente_nome && (
                      <Grid
                        item
                        xs={12}
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        Empresa: <b>{option.cliente_nome}</b>
                      </Grid>
                    )}
                  </Grid>
                </Box>
              )}
              onChange={(event: any, newValue: VacancyListType | null) => {
                if (newValue) {
                  setVacancyId(newValue?.id);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Vaga"
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  autoComplete="off"
                  variant="filled"
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button size="small" onClick={onCloseF}>
          {t("common.cancel")}
        </Button>
        <LoadingButton
          autoFocus
          onClick={sendCandidate}
          loading={pending}
          variant="contained"
          size="small"
          endIcon={<ArrowRight />}
        >
          Encaminhar
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ModalSendCandidateToVacancy;
